import React, { FC } from 'react';
import { Flex, Text, Box } from '@chakra-ui/react';

const PoweredByFooter: FC<{ light?: boolean }> = ({ light = false }) => {
  return (
    <Flex align="center" justify="center" gap={2} py={4}
      borderTop={`1px solid ${light ? 'rgba(255,255,255,0.1)' : '#1E2330'}`}>
      <img
        src="/favicon.gif"
        alt="PokerCity"
        style={{ width: 16, height: 28, objectFit: 'contain' }}
      />
      <Text style={{
        fontFamily: "'Share Tech Mono', monospace",
        fontSize: 10,
        color: light ? 'rgba(255,255,255,0.3)' : '#3A4050',
        letterSpacing: '0.15em',
      }}>
        POWERED BY POKERCITY.COM
      </Text>
    </Flex>
  );
};

export default PoweredByFooter;
